import * as qs from 'query-string';
import * as React from 'react';
import { adopt } from 'react-adopt';
import { Mutation, Query } from 'react-apollo';
import Infinite from "react-infinite";
import InfiniteScroll from 'react-infinite-scroller';
import { withRouter } from "react-router-dom";
import addMovieToListUpdate from 'src/cache/addMovieToList';
import deleteMovieFromListUpdate from 'src/cache/deleteMovieFromList';
import ADD_MOVIE_TO_LIST from "src/mutations/addMovieToList";
import DELETE_MOVIE_FROM_LIST from "src/mutations/deleteMovieFromList";
import listMutationsOptimisticResponse from "src/mutations/listMutationOptimisticResponse";
import GET_SEARCH from "src/queries/getSearch";
import MovieCard from "../components/MovieCard";
import "./Search.css";
import Shell from './Shell';

export class Search extends React.Component<any, any> {

    public render() {
        return (
            <Shell>
                {({ queries }) =>
                    <div className="search-results-page">
                        <div className="ui grid">
                            <div className="ten centered wide column">
                                <SearchResultsComposed
                                    userProfile={queries.getUserProfile.data && queries.getUserProfile.data.userProfile} />
                            </div>
                        </div>
                    </div>
                }
            </Shell>
        );
    }
}

const loadMore = (fetchMore, data) =>
    fetchMore({
        updateQuery: (prev, { fetchMoreResult }) => {
            if (fetchMoreResult.search.items.length === 0) { return prev; }
            return {
                search: {
                    ...fetchMoreResult.search,
                    items: [
                        ...prev.search.items,
                        ...fetchMoreResult.search.items
                    ]
                }
            }
        },
        variables: {
            page: data && data.search && data.search.page + 1
        },
    });

const SearchResults = ({ addMovieToList, deleteMovieFromList, getSearch, userProfile }) => {
    if (!(getSearch.data && getSearch.data.search)) { return null; }
    let headingContent;
    if (getSearch.loading) { headingContent = <span>Searching...</span>; }
    if (!getSearch.loading && getSearch.data.search.pageCount === 0) { headingContent = <span>No results found for "{getSearch.data.search.query}"</span>; }
    if (!getSearch.loading && getSearch.data.search.pageCount > 0) { headingContent = <span>Results for "{getSearch.data.search.query}"</span>; }
    const headingContainer = <div className="ui tabs montserrat bold white font-size-24 margin-bottom-16">{headingContent}</div>;

    return <div>
        {headingContainer}
        <InfiniteScroll
            pageStart={0}
            loadMore={loadMore.bind(this, getSearch.fetchMore, getSearch.data)}
            hasMore={getSearch.data.search.page < getSearch.data.search.pageCount}
            loader={<div className="loader" key={0}>Loading ...</div>}>
            <Infinite useWindowAsScrollContainer={true} elementHeight={187}>
                {getSearch.data.search.items && getSearch.data.search.items.map((movie, i) => {
                    return <MovieCard
                        addMovieToList={addMovieToList}
                        deleteMovieFromList={deleteMovieFromList}
                        listMutationsOptimisticResponse={listMutationsOptimisticResponse}
                        key={movie.id}
                        directors={movie.directors}
                        movieId={movie.id}
                        poster={movie.poster}
                        releaseDate={movie.displayReleaseDate && movie.displayReleaseDate.date}
                        title={movie.title}
                        runtime={movie.runtime}
                        userProfile={userProfile} />
                })
                }
            </Infinite>
        </InfiniteScroll>
    </div>
}

const Compose = adopt({
    addMovieToList: ({ render, userProfile }) =>
        <Mutation
            mutation={ADD_MOVIE_TO_LIST}
            update={addMovieToListUpdate({ userProfile }) as any}>
            {(mutation, result) => render({ mutation, result })}</Mutation>,
    deleteMovieFromList: ({ render, userProfile, tabs }) =>
        <Mutation
            mutation={DELETE_MOVIE_FROM_LIST}
            update={deleteMovieFromListUpdate({ userProfile }) as any}>
            {(mutation, result) => render({ mutation, result })}</Mutation>,
    getSearch: ({ render, location }) =>
        <Query
            query={GET_SEARCH}
            variables={{ page: 1, query: qs.parse(location.search).q }}>{render}</Query>,
})

const SearchResultsComposed = withRouter(({ location, userProfile }) =>
    <Compose location={location} userProfile={userProfile}>{({ addMovieToList, deleteMovieFromList, getSearch }) =>
        <SearchResults
            getSearch={getSearch}
            addMovieToList={addMovieToList}
            deleteMovieFromList={deleteMovieFromList}
            userProfile={userProfile} />}</Compose>)

export default Search;



// WEBPACK FOOTER //
// ./src/containers/Search.tsx